import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1830. 請求タスク削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
};

const destroyInvoiceTask = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.id}`
  );
};

export const useDestroyInvoiceTask = () => {
  return useMutation({
    mutationFn: destroyInvoiceTask
  });
};